import { ACTIONS } from '~/address-book/model/actions'
import { AddressServiceQuery } from '~/gql'

export type AddressBookEntry = AddressServiceQuery['addressbook']['addresses'][0]

export type AddressBookState = {
  isLoading: boolean
  addresses: AddressBookEntry[]
}

const initState: AddressBookState = {
  isLoading: false,
  addresses: [],
}

export const emptyEntry: AddressBookEntry = {
  id: '',
  email: '',
  tags: [],
  phoneNumber: '',
  name: {
    firstName: '',
    lastName: '',
    companyName: '',
    additionalName: '',
  },
  address: {
    countryCode: '',
    zipCode: '',
    city: '',
    street: '',
    number: '',
    addition: '',
    additionalInfo: '',
    additionalAddressLine: '',
  },
}

// eslint-disable-next-line @typescript-eslint/default-param-last, @typescript-eslint/no-explicit-any
export const addressBookReducer = (state: AddressBookState = initState, action: any) => {
  switch (action.type) {
    case ACTIONS.UPDATE_ADDRESSBOOK_REQUESTED:
      return {
        ...state,
        isLoading: true,
        searchTerm: action.payload.searchTerm,
      }
    case ACTIONS.UPDATE_ADDRESSBOOK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addresses: action.payload.addresses,
      }
    default:
      return state
  }
}

const isLoadingAddressBook = (state: AddressBookState): boolean => state.isLoading

const getAddressById =
  (state: AddressBookState) =>
  (addressId: string): AddressBookEntry | undefined => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const address = state.addresses.find((address: AddressBookEntry = emptyEntry) => address.id === addressId)
    return {
      id: address?.id || null,
      tags: address?.tags || [],
      name: {
        firstName: address?.name.firstName || '',
        lastName: address?.name.lastName || '',
        companyName: address?.name.companyName || '',
        additionalName: address?.name.additionalName || '',
      },
      address: {
        countryCode: address?.address.countryCode || '',
        zipCode: address?.address.zipCode || '',
        city: address?.address.city || '',
        street: address?.address.street || '',
        number: address?.address.number || '',
        addition: address?.address.addition || '',
        additionalInfo: '',
        additionalAddressLine: '',
      },
      email: address?.email || '',
      phoneNumber: address?.phoneNumber || '',
    }
  }
export const getAddressesGroupedByName =
  (state: AddressBookState) =>
  (searchTerm: string): Record<string, AddressBookEntry[]> => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const sortedAddressesWithKey = groupAddressessOnKey(state)(searchTerm)
    return Object.keys(sortedAddressesWithKey)
      .sort()
      .reduce((result, key) => {
        // @ts-expect-error
        // eslint-disable-next-line no-param-reassign
        result[key] = sortedAddressesWithKey[key]
        return result
      }, {})
  }

export const groupAddressessOnKey =
  (state: AddressBookState) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (searchTerm: string): Record<string, AddressBookEntry[]> =>
    state.addresses.reduce(
      (acc, address) => {
        const firstChar = address.name.companyName?.charAt(0) || `${address.name.firstName?.charAt(0)}`
        // eslint-disable-next-line no-restricted-globals, radix
        const key = !isNaN(parseInt(firstChar, 1)) ? '#' : firstChar.toUpperCase()

        if (!acc[key]) {
          acc[key] = [address]
        } else {
          acc[key].push(address)
        }
        return acc
      },
      {} as Record<string, AddressBookEntry[]>
    )

export const addressBookSelectors = {
  getAddressesGroupedByName,
  isLoadingAddressBook,
  getAddressById,
}
